import { render, staticRenderFns } from "./administration-users-layout.vue?vue&type=template&id=77921eb6"
import script from "./administration-users-layout.vue?vue&type=script&lang=js"
export * from "./administration-users-layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports